import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  graves: [],
  isLogged: !!localStorage.getItem('token'),
  userInfo: {}
}

const mutations = {
  loadGraves (state, graves) {
    state.graves = graves
  },
  setGraveProperty (state, newProps) {
    state.graves.filter(grave => grave.properties.id === newProps.graveId)[0].properties[newProps.key] = newProps.value
  },
  LOGIN_USER (state) {
    state.isLogged = true
  },

  LOGOUT_USER (state) {
    state.isLogged = false
  },

  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  }
}

const getters = {
  getGraves: (state) => state.graves,
  IS_LOGGED: (state) => state.isLogged,
  getUserInfo: (state) => state.userInfo
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js